import { ResponseInterceptor } from 'app/services/api/interfaces';
import { unauthorizedInterceptor } from './unauthorized.interceptor';
import { errorMessageInterceptor } from './error-message.interceptor';

export const responseInterceptors: Array<ResponseInterceptor> = [
  errorMessageInterceptor,
  unauthorizedInterceptor,
];
